import type { Session } from '@beyond-js/ui/dom';

/**
 * A live transport of a screen (the pending capture's poll) under the family rule for a session that
 * ends while the person works: it sends nothing while the session is not `signed`, a drop is Snapshots'
 * own to say only when the session is `signed` after looking (then it is an outage), and otherwise the
 * family's dialog speaks and the transport reconnects once the session is renewed. Without a `Session`
 * (none yet), a drop is the product's own.
 */
export class Live {
	#renewal: Session | null;

	constructor(renewal: Session | null) {
		this.#renewal = renewal;
	}

	/** Whether a request may be sent now: not while the session is renewed or asked for */
	get open(): boolean {
		return !this.#renewal || this.#renewal.state === 'signed';
	}

	/** After a drop: looks at the session and resolves whether the drop is the product's to say */
	async speaks(): Promise<boolean> {
		if (!this.#renewal) return true;
		return (await this.#renewal.check()) === 'signed';
	}

	/** Resolves at the next renewal, when the transport reconnects; never without a `Session` */
	renewed(): Promise<void> {
		const renewal = this.#renewal;
		return new Promise(resolve => {
			if (!renewal) return;
			const stop = renewal.subscribe(event => {
				if (event.type !== 'renewed') return;
				stop();
				resolve();
			});
		});
	}
}
